module.exports = __webpack_public_path__ + "img/Dortoir.596defc1.jpg";